// Faz 8.6 / Batch A8 — time status → badge tone (single source of truth).
//
// One map per status family, every consumer imports it (AttendanceContent entry
// list + AdminPdksContent timesheet queue) — SSOT rule: fixing a tone here
// propagates everywhere. Tones follow the novem PDKS pill language
// (pdks/admin-*.jsx PStatus + DURUM): in-progress/submitted = warning (apricot),
// approved = success (emerald), locked = info (drawn into payroll), reopened =
// warning (back in the queue), rejected/voided = danger, draft/open = neutral.

import type { BadgeTone } from "@novemai/components";

/** Timesheet lifecycle (open → submitted → approved → locked, reopened). */
export const TIMESHEET_STATUS_TONE: Readonly<Record<string, BadgeTone>> = {
  open: "neutral",
  submitted: "warning",
  approved: "success",
  locked: "info",
  reopened: "warning",
};

/** Individual time-entry status. */
export const ENTRY_STATUS_TONE: Readonly<Record<string, BadgeTone>> = {
  pending: "neutral",
  active: "warning",
  submitted: "warning",
  approved: "success",
  locked: "info",
  rejected: "danger",
  adjusted: "info",
  voided: "danger",
};

/** One shift row (schedule roster); shared by the manager roster and "my shifts". */
export const SHIFT_STATUS_TONE: Readonly<Record<string, BadgeTone>> = {
  open: "warning",
  assigned: "success",
  swapped: "info",
  cancelled: "danger",
  completed: "neutral",
};

/** Schedule lifecycle (draft → published; archived is terminal). */
export const SCHEDULE_STATUS_TONE: Readonly<Record<string, BadgeTone>> = {
  draft: "warning",
  published: "success",
  archived: "neutral",
};
